import React from "react";
import FridgePageTemplate from "./FridgePageTemplate";

const relatedLinks = [
  { to: "/fridge-service-bangalore", label: "Refrigerator Service" },
  { to: "/double-door-refrigerator-service-bangalore", label: "Double Door Service" },
  { to: "/fridge-not-cooling-repair", label: "Not Cooling Repair" },
  { to: "/fridge-compressor-repair", label: "Compressor Repair" },
];

const SingleDoorFridgeService = () => (
  <FridgePageTemplate
    title="Single Door Fridge Service in Bangalore"
    description="Doorstep single door refrigerator service in Bangalore for cooling, compressor, gas, and noise issues."
    keywords="single door fridge service bangalore, single door refrigerator repair, fridge repair bangalore"
    path="/single-door-fridge-service-bangalore"
    bannerTitle="Single Door Fridge Service"
    intro="Book professional single door fridge repair in Bangalore with quick doorstep diagnosis and service support."
    highlights={[
      "Cooling and thermostat checks",
      "Compressor and relay inspection",
      "Gas leakage and refilling support",
      "Door gasket and wiring checks",
    ]}
    issues={[
      "Fridge not cooling",
      "Excess frost formation",
      "Compressor not starting",
      "Water leakage or noise",
    ]}
    relatedLinks={relatedLinks}
  />
);

export default SingleDoorFridgeService;
